module.exports = __webpack_public_path__ + "static/media/closeIcon.3eb3566e.svg";